let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  // Test: V_CLAP_PDP_12 | Pictured Packaging Option Cards on Concentrate PDPs
  const clapPdp12 = window.igData?.user.getTestGroup(
    "866eb5f3-ecf7-4911-9473-2896390b6c82"
  );
  if (clapPdp12?.id === "9ac32a9c-f95c-433b-b7c7-3c8a08e4c646") {
    document.body.classList.add("c-pdp12VarA");
  } else if (clapPdp12?.id === "f85441a6-6a2a-4e5b-85a0-717ad3042930") {
    document.body.classList.add("c-pdp12VarB");
  }

  // Test: V_CLAP_PDP_08 | Founder and Reply Slides in the PDP Gallery
  const vClapPdp08 = window.igData?.user.getTestGroup(
    "3c5c40f9-4370-4b79-8d52-ff3f18141bfb"
  );
  if (vClapPdp08?.id === "790caede-4ca2-40af-83f0-c577036c1950") {
    document.body.classList.add("c-vClapPdp08VarA");
  } else if (vClapPdp08?.id === "24cad087-a494-4f1e-bd83-b78e74b68e01") {
    document.body.classList.add("c-vClapPdp08VarB");
  } else {
    document.body.classList.add("c-vClapPdp08Control");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
